import React from 'react';
export function ProgramsFAQHeader() {
  return <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-2869">
      <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-2870">FAQs</h2>
      <p className="text-lg text-gray-warm" data-id="element-2871">
        Find answers to common questions about our classes, programs, and the
        enrollment process.
      </p>
    </div>;
}